module.exports = __webpack_public_path__ + "media/images/flags/is-bb2810efd3bbd80685ffd27810407700.svg";